"use client";

export default function BasicDetailsStep() {
    return (
        <div className="">
            <h2 className="h4 fw-semibold text-dark mb-0 px-0 py-4">
                Enter Basic Details
            </h2>

            {/* ================= Personal Information ================= */}
            <div className="border mb-0 px-0 py-4 shadow-sm" style={{ borderRadius: "14px" }}>

                <div className="border-0 ">
                    <div className="card-body p-4 pt-0">
                        <div className="d-flex align-items-center mb-4">
                            <span className="text-secondary me-2">
                                <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                </svg>
                            </span>
                            <h5 className="mb-0 fw-semibold text-secondary">
                                Personal Information
                            </h5>
                        </div>

                        <div className="row g-3 mb-3">
                            <div className="col-md-6">
                                <label className="form-label">
                                    Full Name <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter full name"
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">
                                    Mobile Number <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="tel"
                                    className="form-control"
                                    placeholder="+91 XXXXXXXXXX"
                                />
                            </div>
                        </div>

                        <div>
                            <label className="form-label">
                                Email Id <span className="text-danger">*</span>
                            </label>
                            <input
                                type="email"
                                className="form-control"
                                placeholder="Enter email"
                            />
                        </div>
                    </div>
                </div>

                <div className="mx-4 my-0 border-bottom mt-2"></div>

                {/* ================= Contact Details ================= */}
                <div className="border-0">
                    <div className="card-body p-4">
                        <div className="d-flex align-items-center mb-4">
                            <span className="text-secondary me-2">
                                <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                </svg>
                            </span>
                            <h5 className="mb-0 fw-semibold text-secondary">
                                Contact Details
                            </h5>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">
                                Contact Person Name <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter full name"
                            />
                        </div>

                        <div className="row g-3">
                            <div className="col-md-6">
                                <label className="form-label">
                                    Contact Mobile Number <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="tel"
                                    className="form-control"
                                    placeholder="+91 XXXXXXXXXX"
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">
                                    Contact Email <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Enter email"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
